import { IntegracaoVariavelModel } from '../integracao-model';

export class DisparoIntegracaoModel {
  id?: number;
  nome?: string;
  personalizada = false;
  payload = '{}';
  payloadUrl?: string;
  payloadNaoEncontrado?: boolean;
  variaveis: IntegracaoVariavelModel[] = [];
}

export class DisparoIntegracaoPaginaModel {
  content: DisparoIntegracaoModel[] = [];
  totalPages = 0;
  totalElements = 0;
}
